// Sticky add to cart button when user scrolls into view
window.theme = window.theme || {};

window.theme.sizes = {
  mobile: 480,
  small: 768,
  large: 1024,
  widescreen: 1440,
};

const productForm = document.querySelector('.product__submit__holder');
const isMobile = window.innerWidth < window.theme.sizes.small;

function stickyAddToCart() {
  const addToCartBtn = document.querySelector('.product__submit__add');
  const options = {
    root: null,
    rootMargin: '0px 0px 150% 0px',
  };
  const observer = new IntersectionObserver((el) => {
    if (el[0].boundingClientRect.top < 0 && !el[0].isIntersecting) {
      addToCartBtn.classList.add('product__submit__add--sticky');
    } else {
      addToCartBtn.classList.remove('product__submit__add--sticky');
    }
  }, options);
  observer.observe(productForm);
}

document.addEventListener('DOMContentLoaded', () => {
  if (isMobile && productForm) {
    stickyAddToCart();
  }
});
